import { CustomFieldsConfiguration } from '../shared/custom-fields/custom-fields-models';

export class Country {

    countryId: number;

    countryName: string;

    description: string;

    isActive: boolean;

    lastUpdate: any;
}
export class CustomerCFModel {
    CustomerModelEntity: Customer;
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class ContactCFModel {
    CustomerContactUI: CustomerContact;
    CustomFieldEntity: CustomFieldsConfiguration;

}
//added by nagarjuna for Holiday Template in Bussiness houres of customer

export class CustomerHolidayTemplate {
    HolidayTemplateId: number;
    HolidayTemplateName: string;
    IsCustomerTypeHoliday: number;
}
export class Customer {
    CustomerId: number;
    CompanyId: number;
    BillingCustomerId: number;
    CustomerCode: any;
    CustomerTypeId: number;
    ClliCode: string;
    NetworkNo: string;
    NetworkType: string;
    Node: string;
    CustomerStatusId: any;
    StatusReason: string;
    TitleId: any;
    CustomerName: string;
    PrefContactMode: any;
    Email: string;
    Phone1: string;
    Phone2: string;
    Fax: string;
    SpecialInstruction: string;
    ServiceNotes: string;
    CreatedBy: number;
    Createddate: any;
    LastChangedBy: any;
    LastUpdate: any;
    CompanyName: string;
    ContactMode: any;
    TitleName: string;
    ServiceAddress: string;
    BillingAddress: string;
    BillingAccount: string;
    CustomerStatus: string;
    ZipCode: string;
    CustomerType: string;
    IsNetwork: number;

    UnitNo: string;
    AddressLine1: string;
    AddressLine2: string;
    CityName: string;
    StateName: string;
    CountryName: string;

    UnitNos: string;
    AddressLines: string;
    AddressLines2: string;
    CityNames: string;
    StateNames: string;
    CountryNames: string;
    CustomFieldEntity: CustomFieldsConfiguration;
    Password: string;
    NewPassword: string;
    ContactName: string;
    CustomerStatusMasterId: number;
    SearchText: string;
    ProjectName: string;
    TimeZoneCode: string;
    isBillingAccount: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    EquipmentCount: number;

    IsCustomerTypeBusinessHour: number;
    IsCustomerTypeHoliday: number;
}

export class CustomerList {
    Customers: Customer[];
    TotalRecord: number;
}


export class CustomerPM {
    PmId: number;
    PmScheduleId: number;
    StartDate: string;
    EndDate: string;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    StateName: string;
    AddressLines: string;
    AddressLines2: string;
    UnitNos: string;
    CityNames: string;
    StateNames: string;
    CountryName: string;
    CountryNames: string;
    BillingAccount: string;
    Frequency: string;
    AcctualSAddress: string;
    AcctualBAddress: string;
}
export class CustomerPMList {
    CustomerPMLists: CustomerPM[];
    TotalRecord: number;
}

export class FilterOptions {
    constructor(public Id: number,
        public Name: string) { }
}

export class AdvancedSearchModel {
    CustomerTypeId: number;
    CustomerStatusId: number;
    SearchByColumn: string;
    SearchByText: string;
}

export class CustomerStatus {
    CustomerStatusMasterId: any;
    CustomerStatusId: any;
    CustomerStatus: string;
    IsActive: boolean;
    LastChangedBy: any;
    LastUpdate: any;
}


export class State {

    stateId: number;

    countryId: number;

    StateName: string;

    stateShortName: string;

    isActive: boolean;

    lastUpdate: any;
}

export class Address {

    customerAddressId: number;

    companyId: number;

    customerId: number;

    addressName: string;

    addressTypeId: any;

    isPrimary: boolean;

    parentAddressId: any;

    addressLine1: string;

    addressLine2: string;

    unitNo: string;

    cityName: string;

    stateId: any;

    zipCode: string;

    countryId: any;

    userLat: any;

    userLon: any;

    zipLat: any;

    zipLon: any;

    mapLat: any;

    mapLon: any;

    createdBy: number;

    createdDate: any;

    lastChangedBy: any;

    lastUpdate: any;

    isActive: string;

    countryName: string;

    stateShortName: string;
}

export class CustomerTitle {
    ConfigDtlId: number;
    Description: string;
}

export class PreferredContact {
    ConfigDtlId: number;
    Description: string;
}

export class CustomerAddress {
    CustomerAddressId: number;
    CompanyId: number;
    AddressName: string;
    CustomerId: number;
    AddressTypeId: number;
    IsPrimary: any;
    AddressLine1: string;
    AddressLine2: string;
    CityName: string;
    StateName: string
    StateId: number;
    ZipCode: string;
    CountryId: number;
    CountryName: string;
    StateShortName: string;
    UserLat: any;
    UserLon: any;
    UnitNo: number;
    Active: number;
    ZipLat: number;
    ZipLon: number;
    MapLat: any;
    MapLon: any;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    IsActive: any;
    RegionId: number;
    ChangePrimary: number;
    CopyAddress: number;
    CopyBillingAccount: number;
    CreatedSourceId: number;
    UpdatedSourceId: number;
    //CustomerContactDetails: CustomerContactDetails[];
}

export class CustomerAddresslist {
    CustomerAddressId: number;
    AddressName: string;
    AddressType: string;
    AddressTypeId: number;
    IsPrimary: any;
    AddressLine1: string;
    AddressLine2: string;
    Address: string;
    UnitNo: string;
    CityName: string;
    StateName: string;
    ZipCode: string;
    CountryId: string;
    IsActive: any;
    UserLat: any;
    UserLon: any;
    AcctualAddress: string;
    TimeZoneCode: string;
}

export class AddressList {
    CustomerAddresses: CustomerAddresslist[];
    TotalRecord: number;
}
export class CountryList {
    CountryId: number;
    CountryName: string;
    Description: string;
    IsActive: Boolean;
    LastUpdate: Date;
}

export class Regions {
    RegionId: number;
    Region: string;
}

export class AddressTypes {
    AddressTypeId: number;
    AddressType: string;
}

export class CustomerContact {
    CustomerContactId: number;
    CompanyId: number;
    CustomerId: number;
    CustomerAddressId: number;
    AddressTypeId: number;
    Phone1: string;
    Phone2: string;
    Email: string;
    IsPrimary: any;
    TitleId: number;
    FirstName: string;
    MiddleInitial: string;
    LastName: string;
    ContactTypeId: string;
    Fax: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    ContactType: string;
    TitleName: string;
    ChangePrimary: any;
    CreatedSourceId: number;
    UpdatedSourceId: number;
}

export class ContactList {
    CustomerContacts: CustomerContactlist[];
    TotalRecord: number;
}

export class CustomerContactlist {
    CustomerContactId: number;
    Phone1: string;
    Phone2: string;
    Email: string;
    IsPrimary: any;
    FirstName: string;
    AddressLine1: string;
    ContactType: string;
    AddressType: string;
    Fax: string;
    IsActive: any;
    Address: string;
    AcctualAddress: string;
}

export class ContactType {
    ConfigDtlId: number;
    Description: string;
}

export class AddressName {
    AddressName: string;
    CustomerAddressId: number;
    IsPrimary: number;
}

export class BillingAccountList {
    BillingAccounts: BillingAccountlist[];
    TotalRecord: number;
}

export class BillingAccountlist {
    CustomerId: number;
    CustomerName: string;
    AddressName: string;
    AddressLine1: string;
    FirstName: string;
    Phone1: string;
    IsPrimary: any;
    IsActive: any;
    BillingAccountId: number;
    AcctualAddress: string;
}

export class BillingAccount {
    BillingAccountId: number;
    CompanyId: number;
    CustomerId: number;
    CustomerName: number;
    AddressName: string;
    BillingCustomerId: number;
    CustomerAddressId: number;
    Remarks: string;
    IsPrimary: any;
    IsActive: any;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    StateName: string;
    Country: string;
    AcctualAddress: string;
}

export class Filteroptions {
    constructor(public id: number,
        public name: string) { }
}
export class RecentWorkOrder {
    WorkOrderId: number;
    WoNumber: string;
    WoStatusId: number;
    JobNo: number;
    JobStatusId: number;
    WorkTaskId: number;
    WorkTask: string;
    WorkType: string;
    CreatedBy: string;
    CreatedDate: string;
    ClosedDate: string;
    TechName: string;
    IsPmOrder: any;
    WoCategory: string;
    InvoiceBy: string;
    AddressLine1: string;
    InvoiceDate: string;
    RequestedBy: string;
}

export class CustomerEquipmentslist {
    BrandName: string;
    Model: string;
    ModelId: number;
    SerialNo: string;
    TagNo: string;
    Description: string;
    CustomerEquipmentId: string;
    AddressName: string;
    IsActive: any;
    ContractStartDate: string;
    ContractEndDate: string;
    IsContractExpiredColor: string;
    ContractType: string;
    ContractTypeId:number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
    InstallationDate: string;
    counts: number;

}
export class CustomerEquipmentsList {
    CustomerEquipments: CustomerEquipmentslist[];
    TotalRecord: number;
}
export class EquipmentCFModel {
    CustomerEquipment: CustomerEquipment;
    CustomFieldEntity: CustomFieldsConfiguration;

}
export class DataList {
    ValueId: any;
    Value: any;
}
export class CustomerEquipment {
    CustomerEquipmentId: number;
    CompanyId: number;
    CustomerId: number;
    CustomerAddressId: number;
    BrandId: number;
    ModelId: number;
    SerialNo: string;
    TagNo: string;
    Description: string;
    InstallationDate: string;
    IsActive: any;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    BrandName: string;
    Model: string;
    ContractStartDate: string;
    ContractEndDate: string;
    TimezoneId: number;
    PriorityId?: number;
    ContractTypeId: number;
    ManufactureDate: string;
    WarrantyExpiryDate: string;
  
    //Added by senthil g for equipment integration on 12 Jul 2019
    //EquipmentRefId?: number;
    //CreatedSourceId?: number;
    //UpdatedSourceId?: number;
}

export class CustomerDetails {
    CompanyID: number;
    CustomerId: number;
    CustomerCode: any;
    CustomerName: string;
    AddressLine1: string;
    CustomerType: string;
    phone1: string;
    phone2: string;
    Email: string;
    CustomerStatus: string;
    SortBy: string;
    OrderBy: string;
    startRecord: number;
    EndRecord: number;
}
export class CustomerDetailsListEntity {
    CustomerList: CustomerDetails[];
    TotalRecord: number;
}

/**Autolookup select List Properties */
export class CustomerAutoComp {
    CustomerId: number;
    CustomerName: string;
    Phone1: string;
    CustomerType: string;
}

export class PrimaryBillingAddress {
    string; AddressName: string;
    AddressLine1: string;
    AddressLine2: string;
    UnitNo: string;
    CityName: string;
    CustomerId: number;
    StateName: string;
    Country: string;
}

/**Model for Special instructions */
export class Specialinfo {
    tempId: number;
    NotesID: number;
    NotesMasterId: number;
    PrimaryKeyId: number;
    CompanyId: number;
    Note: string;
    CreatedBy?: number;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate?: string;
    Name: string;
    UpdateDate: string;
    CreatedSourceId: number;
    UpdatedSourceId: number;
}



export class CustomerType {
    CustomerTypeId: number;
    CompanyId: number;
    CustomerType: string;
    Description: string;
    IsActive: number;
    InActive: boolean;
    CreatedBy: number;
    LastChangedBy: number;
    IsSystemDefined: number;
    IsNetwork: number;
    Status: string;
    PriorityId: number;
    DispatchBoardAccess: any;
    LiveMapAccess: any;
    DashboardAccess: any;
    LogoPath: string;
    CustomerPortalAccess: any;
    IsClinetOrderAutoSchedule: any;
    IsAutoAuthorize: any;
    HolidayTemplateId: number;
    CustomerTypeNo:string;
}




export class CustomerTypes {

    CustomerTypeId: number;

    CompanyId: number;

    CustomerType: string;

    Description: string;

    IsActive: number;

    IsSystemDefined: number;

    IsNetwork: number;

    Status: string;
}

export class CustomerTypeList {
    CustomerType: CustomerType[];
    TotalRecord: number;
}

export class CustomerTypeStatus {

    Search: string;

    Status: boolean;


}

export class CTBusinessHour {
    CustomerTypeBusinessHourId: number;
    CompanyId: number;
    CustomerTypeId: number;
    WeekDay: any;
    DayStartHour: string;
    DayEndHour: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Is24Hour: any;
    DayStartHourTag: string;
    DayEndHourTag: string;
}

export class CustomerPreferTech {
    CustomerPreferTechId: number;
    CompanyId: number;
    CustomerId: number;
    TechId: number;
    CustPreferTypeId: number;
    CreatedBy: number;
    CreatedDate: any;
    LastChangedBy: any;
    LastUpdate: any;
    VendorId: number;
    CustomerTypeValue: number;
}

export class CustomerPreferTechList {
    CustomerPreferTechId: number;
    DisplayName: string;
    CustPreferType: string;
}

export class CustomerPreferTechListEntity {
    CustomerPrefTechs: CustomerPreferTechList[];
    TotalRecord: number;
}

export class Vendor {
    VendorId: number;
    VendorName: string;
}

export class Technician {
    Email: string;
    LoginId: number;
    FirstName: string;
    LastName: string;
    DisplayName: string;
    Phone1: number;
    Phone2: number;
    Designation: string;
    ManagerId: number;
    UniquRefNo: string;
    Roles: string;
    Manager: string;
    Zones: string;
    Regions: string;
    IsActive: number;
    VendorId: number;
}

export class CustomerPreferType {
    CustPreferTypeId: number;
    CustPreferType: string;
}


export class BrandList {
    BrandId: number;
    Brand: string;

}
export class ValueList {
    ValueId: number;
    Value: string;

}
export class ModelList {
    ModelId: number;
    Model: string;

}

export class ContractTypeList {
    ContractTypeId: number;
    ContractType: string;

}

export class ContractType{
    ContracttypeId : number;
    CompanyId : number;
    ContractType : string;
    IsActive : number;
}

export class BusinessHour {
    CustomerBusinessHourId: number;
    CompanyId: number;
    CustomerId: number;
    WeekDay: any;
    DayStartHour: string;
    DayEndHour: string;
    IsActive: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    Is24Hour: any;
    DayStartHourTag: string;
    DayEndHourTag: string;
}

// export class UpdateBusinessHour 
// {
//     CompanyId: number;
//     CustomerId: number;
//     IsCustomerTypeBusinessHour:number;
// }



export class Priority {
    PriorityId: number;
    CompanyId: number;
    PriorityName: string;
    Description: string;
    Color: string;
    SlaDays: number;
    SlaHours: number;
    SlaMinutes: number;
    SlaStartsFrom: number;
    SlatStopStatusId: number;
    IsActive: number;
    CreatedBy?: number;
    CreatedDate: string;
    LastChangedBy?: number;
    LastUpdate: string;
    IsDefault: number;
    ResponseSlaDays?: number;
    ResponseSlaHours?: number;
    ResponseSlaMinutes?: number;
    RespSLADurationTypeId?: number;
    ReslSLADurationTypeId?: number;
    RespSLADurationType: string;
    ReslSLADurationType: string;
    IsResponseSlaEnabled?: number;
    IsResolutionSlaEnabled?: number;
    respreslstring: string;
    SLAtype: string;
    SLADropdown: string;
    SLADropdownlist: string;
}

export class TemplateDetails {

    HolidayTemplateId: number;
    HolidayTemplateName: string;
    Description: string;
    IsDefault: number;
    CreatedBy: number;
    CreatedDate: string;
    LastChangedBy: number;
    LastUpdate: string;
    CompanyId: number;
}
export class CustomerAttachment {
    CompanyId: number;
    CustomerId: number;
    CreatedBy: number;
    Description: string;
    AttachmentType: string
    AttachmentTypeId: number
    FileName: string;
    CustomerAttachmentId: number;
    Attachment: string;
    DocType: boolean;
    DocThumbImage: string;
    AttachmentCategoryId: number;
    CreatedByName: string;
    CapturedDate: string;
    CreatedDate: string;
    LastChangedBy: number;
    LastChangedByName: string;
    LastUpdate: string;

}
export class CustomerAttachmentEntity {
    CompanyId: number;
    CustomerId: number;
    Description: string;
    AttachmentType: string
    AttachmentTypeId: number
    FileName: string;
    CustomerAttachmentId: number;
    Attachment: string;
    DocType: boolean;
    DocThumbImage: string;
    AttachmentCategoryId: number;
    CreatedBy: number;
    CreatedByName: string;
    CapturedDate: string;
    CreatedDate: string;
    LastChangedBy: number;
    LastChangedByName: string;
    LastUpdate: string;
}

export class CheckWorkOrder {
    WorkOrderId: number;
    CustomerId: number;
    WoNumber: string;
    WoStatusId: number;
    WoJobId: number;
    WoCategoryId: number;
    TechId: number;
}


export class CustomerVendor {
    CustomerVendorId: number;
    CustomerId: number;
    VendorName: string;
    VendorId: number;
}


export class CustomerVendorEntity {
    CustomerVendorId: number;
    CustomerId: number;
    CompanyId:number;
    VendorId: number;
    CreatedBy: number;
    CreatedDate:string;
    VendorIds: number[];
    IsAllVendorMapped: number;
}

export class AddCustomerEntity {
    CustomerEntity: Customer;
    AddressEntity: CustomerAddress;
}

//Elixir specific
export class CustomerMultipleLogin{
    MultipleLoginId: number;
    Email: string;
    Password: string;
    CompanyId: number;
    CustomerId: number;
    LoginId: number;
}
